import { Grid, Paper } from '@mui/material';
import type { HomePageQuickLinkNavButtonProps } from './HomePageQuickLinksNavButton';
import { HomePageQuickLinkNavButton } from './HomePageQuickLinksNavButton';

const quickLinkButtonsProps: Array<HomePageQuickLinkNavButtonProps> = [
  {
    label: 'New Pricing Plan',
    to: '/plans/create',
  },
  {
    label: 'Product to Meter',
    to: '/products',
  },
  {
    label: 'Create Invoice',
    to: '/invoices/create',
  },
];

export const HomePageQuickLinksSection: React.FC = () => {
  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: 3,
      })}
    >
      <Grid
        container
        columnSpacing={2}
      >
        {quickLinkButtonsProps.map((quickLinkButtonProps) => (
          <Grid
            key={crypto.randomUUID()}
            item
            xs={4}
          >
            <HomePageQuickLinkNavButton
              {...quickLinkButtonProps}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};